import {Box, Typography, useTheme} from "@mui/material";

const ScopeInfo = ({scope}) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography variant="h4" gutterBottom color={theme.palette.text.primary}>
        {scope?.name}
      </Typography>
      <Typography variant="h4" gutterBottom color={theme.palette.text.primary}>
        {scope?.description}
      </Typography>
    </Box>
  );
};

export default ScopeInfo;
